<template>

<div class="band" :class="{'is-white': !config.colors}" :style="style">

	<div class="band-name">{{ value / 100 | round(2) }}</div>
	<div class="band-score" v-if="config.subtitles">{{ name }}</div>

</div>

</template>

<script>

export default {

	props: ['value', 'config'],

	computed: {

		style: function() {

			if(!this.config.colors) return false

			var style = {
				backgroundColor: false
			}

			this.$_.each(this.config.colors, function(hex, threshold) {

				if (threshold <= this.value) style.backgroundColor = hex

			}.bind(this))

			return style

		},

		name: function() {

			var name = 0

			this.$_.each(this.config.bands, function(band, threshold) {

				if (threshold <= this.value) name = band

			}.bind(this))

			return name

		},

		subtitle: function() {

			var name = 0

			this.$_.each(this.config.subtitles, function(subtitle, threshold) {

				if (threshold <= this.value) name = subtitle

			}.bind(this))

			return name

		}

	}

}

</script>

<style scoped>

.band {
	display: flex;
	flex-direction: column;
	width: 100%;
	border-bottom: 1px solid #fff;
	border-radius: 4px 4px 0px 0px;
	justify-content: center;
	align-items: center;
	color: #fff;
}

.band.is-white {
	color: #4881bb;
}

.band-name {
	font-size: 28px;
	line-height: 28px;
	padding: 0px 10px;
}

.band-score {
	font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    margin-top: 4px;
    text-align: center;
}

</style>